import {
  GET_ADMIN_BILLING_EVENTS,
  GET_ADMIN_BILLING_EVENTS_SUCCESS,
  GET_ADMIN_BILLING_EVENTS_ERROR,
  GET_BILLING_EVENTS_FILTER_OPTIONS,
  GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS,
  GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  billing_events: [],
  error: null,
  loading: false,
  last_page_fetched: 0,
  total_number_of_pages: 0,
  filter_options: {},
  filter_options_loading: false,
  filter_options_error: null,
  has_next_page: false,
  has_lookahead_pages: false,
  page_cache: {},
  active_cache_key: null,
}

const AdminBillingEvents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_BILLING_EVENTS:
      const pageNum_req = parseInt(action.payload?.page_number) || 1;
      const useCache_req = Boolean(action.payload?.useCache);
      const cacheKey_req = action.payload?.cacheKey;
      const shouldResetCache = useCache_req && pageNum_req === 1 && !action.payload?.appendResults &&
        state.active_cache_key && state.active_cache_key !== cacheKey_req;
      const cachedPage = useCache_req ? state.page_cache?.[cacheKey_req]?.[pageNum_req] : null;

      return {
        ...state,
        loading: !cachedPage,
        active_cache_key: useCache_req ? cacheKey_req : state.active_cache_key,
        billing_events: cachedPage?.rows || ((pageNum_req === 1 || !action.payload?.appendResults) ? [] : state.billing_events),
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }

    case GET_ADMIN_BILLING_EVENTS_SUCCESS:
      const rows = (Array.isArray(action.payload?.data) ? action.payload.data : []).map((billingEvent) => ({
        ...billingEvent,
        id: billingEvent?.id || billingEvent?.raw_data?.id,
      }));
      const additionalData = action.payload?.additional_data || {};
      const pageNum = parseInt(additionalData?.page_number, 10) || 1;
      const totalPages = parseInt(additionalData?.total_number_of_pages, 10) || 0;
      const hasNextPage = typeof additionalData?.has_next_page === 'boolean'
        ? additionalData.has_next_page
        : pageNum < totalPages;
      const hasLookAhead = Boolean(additionalData?.has_lookahead_pages);
      const useCache = Boolean(action.meta?.useCache);
      const cacheKey = action.meta?.cacheKey;
      const appendResults = Boolean(action.meta?.appendResults);
      const pageSnapshot = useCache ? {
        rows,
        page_number: pageNum,
        total_number_of_pages: totalPages,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAhead,
      } : null;

      return {
        ...state,
        loading: false,
        billing_events: appendResults
          ? [...state.billing_events, ...rows]
          : rows,
        last_page_fetched: pageNum,
        total_number_of_pages: totalPages,
        has_next_page: hasNextPage,
        has_lookahead_pages: hasLookAhead,
        active_cache_key: useCache ? cacheKey : state.active_cache_key,
        page_cache: useCache && pageSnapshot ? {
          ...state.page_cache,
          [cacheKey]: {
            ...(state.page_cache?.[cacheKey] || {}),
            [pageNum]: pageSnapshot,
          }
        } : state.page_cache,
      }

    case GET_ADMIN_BILLING_EVENTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        has_next_page: false,
        has_lookahead_pages: false,
      }
    case GET_BILLING_EVENTS_FILTER_OPTIONS:
      return {
        ...state,
        filter_options_loading: true,
        filter_options_error: null
      }
  
    case GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        filter_options_loading: false,
        filter_options: action.payload,
        filter_options_error: null
      }

    case GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR:
      return {
        ...state,
        filter_options_loading: false,
        filter_options_error: action.payload
      }

    default:
      return state
  }
}

export default AdminBillingEvents
